var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticStyle:{"width":"100%"},attrs:{"id":"select2ajax-template"}})
}
var staticRenderFns = []

export { render, staticRenderFns }